module.exports = __webpack_public_path__ + "091bc36db78d4ebb92c0681e85306273.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/home-about-hero.jpg
// module id = 28
// module chunks = 0